import { Link, LinkSize, LinkTheme } from '@vivino/js-react-common-ui';
import { getCurrentCountryCode, isVCCountry, useI18N } from '@vivino/js-web-common';
import { RubyLibFullVintage } from '@webtypes/rubyLibApi';
import React, { useState } from 'react';
import { track } from 'vivino-js/analytics';

import ShopsModal from 'vivino-js/components/ShopsModal/ShopsModal.presentational';

const TRANSLATIONS = {
  showAllBuyingOptions: 'components.buying_options.show_all_buying_options',
  averageOnlinePricesFrom: 'components.buying_options.average_online_prices_from',
  externalShops: 'components.buying_options.external_shops',
};

interface BuyingOptionsProps {
  vintage: RubyLibFullVintage;
  className?: string;
  ppcContext?: boolean;
}

const BuyingOptions = ({ vintage, ppcContext, className }: BuyingOptionsProps) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const { t } = useI18N();

  const isCurrentCountryVc = isVCCountry(getCurrentCountryCode());

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault(); // to prevent scroll-to-top

    setShowModal(true);
  };

  const externalShopsLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const eventName = 'Purchase Availability External Shops - Click';
    track({ event: eventName, props: { link_version: 'New' } });

    handleClick(e);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      {ppcContext ? (
        <div className={className}>
          {t(TRANSLATIONS.averageOnlinePricesFrom) + ' '}
          <>
            {isCurrentCountryVc ? (
              <>{t(TRANSLATIONS.externalShops)}</>
            ) : (
              <Link
                href="#"
                theme={LinkTheme.Monochrome}
                size={LinkSize.Small}
                onClick={externalShopsLinkClick}
              >
                {t(TRANSLATIONS.externalShops)}
              </Link>
            )}
          </>
        </div>
      ) : (
        <Link href="#" theme={LinkTheme.Monochrome} size={LinkSize.Small} onClick={handleClick}>
          {t(TRANSLATIONS.showAllBuyingOptions)}
        </Link>
      )}

      <ShopsModal
        vintage={vintage}
        show={showModal}
        onClose={handleClose}
        displayVcShops
        hidePPCLink={isCurrentCountryVc}
      />
    </>
  );
};

export default BuyingOptions;
